export enum SubscriptionStatus {
  Unpaid = 'unpaid',
  Active = 'active',
  Canceled = 'canceled',
}
